module.exports = __webpack_public_path__ + "static/media/showcase8.c465601a.webp";